module.exports = __webpack_public_path__ + "img/Doorbell_Pairing-Mode_Light_poster.a6ed4493.png";